import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import Footer from '../NewApply/Footer';
import Input from '../Banking/Input';
import Header from '../NewProfile/Header';

import EncourageScroll from '../EncourageScroll';
import ScrollLock from 'react-scrolllock';

import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';

import '../Banking/bankingInfo.css';

class BankingInfo extends Component {
  constructor(props) {
    super(props);

    const { institutionNumber, transitNumber, accountNumber, hstNumber } = props.currentUser;
    this.state = {
      edit: !hstNumber,
      hstNumber: hstNumber || '',
      errors: {
        hstError: '',
      },
    };
  }

  updateUser = () => {
    const { institutionNumber, transitNumber, accountNumber, hstNumber } = this.state;
    this.props.client
      .mutate({
        mutation: UPDATE_USER,
        variables: {
          userFields: {
            hstNumber,
          },
        },
      })
      .then(() => this.setState({ edit: false }))
      .then(() => this.props.refetch());
  };

  verifyValues = () => {
    let { hstNumber } = this.state;
    let hstError = '';
    hstNumber = hstNumber.replace(/\s/g, '');

    if (!hstNumber) {
      hstError = 'HST Number must be a number.';
    } else if (!hstNumber.match(/(^\d{9}$)|(^\d{9}[a-zA-Z]{2}\d{4}$)/)) {
      hstError = 'HST Number is not valid.';
    } 
    this.setState({ errors: { hstError } });
    return !hstError;
  };

  onChange = (key, value) => this.setState({ [key]: value });

  onClick = () => {
    if (this.state.edit) {
      if (this.verifyValues()) {
        this.updateUser();
      }
    } else {
      this.props.history.push('/profile');
    }
  };

  render() {
    const { history } = this.props;
    const { hstNumber, edit, errors } = this.state;
    const { hstError } = errors;

    return (
      <Fragment>
        <div className="apply__progress--header">
          <Header title="Profile" persistentTitle back disable onClick={() => history.goBack()} />
        </div>
        <Footer
          label={edit ? 'Submit' : 'Profile'}
          back
          active
          onBackClick={() => history.goBack()}
          onNextClick={this.onClick}
        />
        <div className="apply">
          <div className="apply__body container apply__body--progress">
            <ScrollLock>
              <EncourageScroll className="banking-info__body">
                <div className="banking-info__container">
                  <div className="banking-info__content">
                    <div className="banking-info__inputs">
                      <Input
                        heading="HST Number"
                        isInput={edit}
                        value={hstNumber.toUpperCase()}
                        error={hstError}
                        onChange={evt => this.onChange('hstNumber', evt.target.value)}
                      />
                    </div>
                    {!edit ? (
                      <div className="banking-info__toggle" onClick={() => this.setState({ edit: true })}>
                        Edit
                      </div>
                    ) : null}
                  </div>
                </div>
              </EncourageScroll>
            </ScrollLock>
          </div>
        </div>
      </Fragment>
    );
  }
}

const UPDATE_USER = gql`
  mutation updateUser($userFields: UserAttributes!) {
    updateUser(userFields: $userFields) {
      user {
        email
      }
      errors {
        message
      }
    }
  }
`;

export default withRouter(withApollo(BankingInfo));



// WEBPACK FOOTER //
// ./src/components/Hst/HstNumber.js